import React, { createRef, memo, useState } from 'react';
import { Header } from '../../components/layout/header';
import Search from 'antd/es/input/Search';
import { Button, Dropdown, message, Modal, Switch } from 'antd';
import { useDebounce } from '../../hook/use-debounce';
import { GeneralApi, MeApi, PermissionApi, UserApi } from '../../apis';
import { Table, TableRef } from '../../components/table/table';
import { BranchFormRef } from '../../components/branch/form';
import { PlusCircleOutlined } from '@ant-design/icons';
import { UserForm } from '../../components/uer/form';
import { ChangePasswordForm } from '../../components/uer/password';
import useSWR from 'swr';
import { PermissionCode, useRole } from '../../hook/use-role';

const PAGE_NAME = PermissionCode.USER;
const PAGE_NAME_STATUS = PermissionCode.USER_STATUS_CHANGE;

const UserListScreen = memo(() => {
  const [value, setValue] = useState<string | undefined>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [action, setAction] = useState<any>();
  const [changePassword, setChangePassword] = useState<string>();
  const { data } = useSWR('/api/init', GeneralApi.init);

  const { check } = useRole();

  console.log('data :', data);

  const [messageApi, contextHolderMessage] = message.useMessage();

  const formRef = createRef<BranchFormRef | null>();
  const tableRef = createRef<TableRef>();

  const query = useDebounce(value, 300);
  useSWR('/api/permission/select', PermissionApi.select);

  const column = columns({
    options: {
      isDelete: check.isDelete(PAGE_NAME),
      isUpdate: check.isEdit(PAGE_NAME),
      updateStatus: check.isAccess(PAGE_NAME_STATUS),
    },
    checked: async (id: string, status: 'ACTIVE' | 'INACTIVE') => {
      await UserApi.changeStatus(id, status);
      tableRef.current?.reload();
    },

    setType: async (type: 'password' | 'update', id: string) => {
      console.log('type :', tableRef.current);

      switch (type) {
        case 'update':
          const res = await UserApi.get(id);
          setAction({
            ...res,
            branchId: res?.id,
          });
          setIsModalOpen(true);
          break;
        case 'password':
          setChangePassword(id);
      }
    },
  });

  const onSearch = (value: any) => {
    setValue(value.target.value);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    formRef.current?.submitForm();
    // console.log('REs :');
    // if (res) {
    //   onSubmit(res);
    // }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setAction(undefined);
  };

  const onSubmit = async (values: any) => {
    console.log('values :', values);
    try {
      if (action) {
        await UserApi.update({
          ...values,
          id: action.id,
        });

        setIsModalOpen(false);
        setAction(undefined);
        tableRef.current?.reload();

        messageApi.success('Амжилттай засварлалаа');
      } else {
        await UserApi.create(values);

        setIsModalOpen(false);

        tableRef.current?.reload();
        messageApi.success('Амжилттай');
      }
    } catch (err: any) {
      messageApi.error(err?.message);
    }
  };

  return (
    <>
      {contextHolderMessage}
      <div className="flex-col bg-white rounded-[8px] p-5">
        <Header title="Хэрэглэгч удирдлага" isGoBack={false} />
        <div className="">
          <div className="flex flex-row justify-between pb-[20px]">
            <div className="flex flex-row">
              <Search placeholder="Хайх..." onChange={onSearch} style={{ width: 300 }} />
              <div className="w-[10px]" />
              <Button type="default">Цэвэрлэх</Button>
            </div>
            {check.isCreate(PAGE_NAME) && (
              <Button type="primary" onClick={showModal} icon={<PlusCircleOutlined />}>
                Нэмэх
              </Button>
            )}
          </div>
          <Table ref={tableRef} columns={column} loadData={UserApi.list} query={query} />
        </div>
      </div>

      {isModalOpen && (
        <Modal
          title="Хэрэглэгч"
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Хадгалах"
          cancelText="Буцах"
          maskClosable={false}
        >
          <UserForm action={action} ref={formRef} onSubmit={onSubmit} />
        </Modal>
      )}
      {changePassword && (
        <Modal
          title="Хэрэглэгч"
          onCancel={() => setChangePassword(undefined)}
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={changePassword ? true : false}
          footer={null}
        >
          <ChangePasswordForm
            userId={changePassword}
            onSubmit={async (values) => {
              try {
                await MeApi.password({
                  password: values.password,
                  id: changePassword,
                });
                messageApi.success('Нууц үг амжилттай шинэчлэгдлээ.');
              } catch (e: any) {
                messageApi.error(e?.message);
              }
              setChangePassword(undefined);
            }}
          />
        </Modal>
      )}
    </>
  );
});

const columns: any = ({
  setType,
  checked,
  options,
}: {
  setType: (type: 'password' | 'update', id: string) => void;
  checked: (id: string, status: 'ACTIVE' | 'INACTIVE') => void;
  options: {
    isDelete: boolean;
    isUpdate: boolean;
    updateStatus: boolean;
  };
}) => [
  {
    title: '#',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    render: (_: any, __: any, index: any) => index + 1,
  },
  {
    title: 'Овог нэр',
    render: (item: any, __: any, index: any) => (
      <label>
        {item.lastName} {item.firstName}
      </label>
    ),
    key: 'fullname',
  },
  {
    title: 'Регистрийн дугаар',
    render: (item: any, __: any, index: any) => <label>{item.registerNo}</label>,
    key: 'registerNo',
  },
  {
    title: 'Утасны дугаар',
    render: (item: any, __: any, index: any) => <label>{item.phone}</label>,
    key: 'phone',
  },
  {
    title: 'role',
    render: (item: any, __: any, index: any) => <label>{item.type}</label>,
    key: 'type',
  },
  {
    title: 'Салбар',
    render: (item: any, __: any, index: any) => <label>{item?.branch?.name}</label>,
    key: 'branchId',
  },

  {
    title: 'Email',
    render: (item: any, __: any, index: any) => <label>{item?.email}</label>,
    key: 'email',
  },

  {
    title: options?.updateStatus === false ? 'Статус' : '',
    render: (item: any, __: any, index: any) => {
      if (!options?.updateStatus) {
        return;
      }
      return (
        <Switch
          onClick={(e) => checked(item.id, e === true ? 'ACTIVE' : 'INACTIVE')}
          checked={item.status === 'ACTIVE'}
        />
      );
    },
    key: 'branchId',
  },
  {
    key: 'rowIndex',
    width: 150,
    align: 'center',
    render: (item: any, _: any, index: any) => {
      if (!options?.isUpdate) {
        return <></>;
      }

      return (
        <Dropdown
          trigger={['click']}
          menu={{
            items: [
              {
                key: 'update',
                label: <span>Засах</span>,
                onClick: () => {
                  setType('update', item?.id!);
                },
              },
              {
                key: 'password',
                label: <span>Нууц үг</span>,
                onClick: () => {
                  setType('password', item?.id!);
                },
              },
            ],
          }}
          arrow
          placement="bottomLeft"
        >
          <Button type="default">Үйлдэл</Button>
        </Dropdown>
      );
    },
  },
];

UserListScreen.displayName = 'UserListScreen';

export { UserListScreen };
